module.exports = __webpack_public_path__ + "static/media/v-down-active.571e3746.svg";